import { useDynamicContext } from "@dynamic-labs/sdk-react-core";

import { ChainId, isMainnet } from "#/config/web3/contractAddresses";
import { isChainSupported } from "#/utils/isChainSupported";

export const useChainId = () => {
  const { network } = useDynamicContext();

  if (!network || !isChainSupported(Number(network)))
    return { chainId: isMainnet ? ChainId.ARBITRUM : ChainId.ARBITRUM_SEPOLIA };

  return { chainId: Number(network) as ChainId };
};
